var React = require('react');

function CheckNew (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.804 2.16486L5.90446 12.0644C5.64412 12.3247 5.22201 12.3247 4.96166 12.0644L4.01885 11.1216C4.01872 11.1214 4.01897 11.1217 4.01885 11.1216L0.19575 7.29845C-0.0645991 7.0381 -0.0645991 6.61599 0.19575 6.35565L1.13856 5.41284C1.39891 5.15249 1.82102 5.15249 2.08137 5.41284L5.43306 8.76453L13.9183 0.279247C14.1787 0.018897 14.6008 0.018897 14.8612 0.279247L15.804 1.22206C16.0643 1.48241 16.0643 1.90452 15.804 2.16486Z","fill":"#FF8732"}));
}

CheckNew.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none"};

module.exports = CheckNew;

CheckNew.default = CheckNew;
